import { IUserLanguage, IUserLanguageAction } from 'models/user/userlanguage';
//import { IStore } from 'redux/IStore';
import * as i18n from 'i18next';
import { IStore } from 'redux/IStore';
import * as c from 'models/constants';
import { cookies } from 'helpers/cookies';
const config = require('../../../../../../config/main');

/** Action Types */
export const GET_REQUEST: string = 'userlanguage/GET_REQUEST';
export const GET_SUCCESS: string = 'userlanguage/GET_SUCCESS';
export const GET_FAILURE: string = 'userlanguage/GET_FAILURE';
export const CHANGE_LANGUAGE: string = 'userlanguage/CHANGE_LANGUAGE';
export const INIT_I18XHR: string = 'userlanguage/INIT_I18XHR';
import * as moment from 'moment';
import { putUserPreferences } from '../userpreferences';

/** Initial State */
const initialState: IUserLanguage = {
	isFetching: false,
	languageKey: null,
	culture: null,
	hackFlagDispatched: false, //hack flag to know if language was already set from dispatch or is not null because of fallBackLanguage on serverside
};

/** Reducer */
export function userLanguageReducer(state = initialState, action: IUserLanguageAction) {
	switch (action.type) {
		case CHANGE_LANGUAGE:
			return Object.assign({}, state, {
				languageKey: action.payload.userLanguage.languageKey,
				culture: action.payload.userLanguage.culture,
				hackFlagDispatched: action.payload.userLanguage.hackFlagDispatched,
			});

		default:
			return state;
	}
}

export function changeUserLanguage(
	languageKey: number,
	culture: string,
	hackFlagDispatched: boolean = false,
): IUserLanguageAction {
	return {
		type: CHANGE_LANGUAGE,
		payload: {
			userLanguage: {
				languageKey,
				culture,
				hackFlagDispatched,
			},
		},
	};
}

/** Action Creator */
export function changeLanguage(languageKey: number, updateUserPreferences: boolean) {
	return (dispatch, getState: () => IStore) => {
		const lang = getState().domainValues.languages.filter((x) => languageKey === x.key);
		if (!lang || lang.length === 0) {
			throw new Error('Language domain value not found');
		}
		const culture = lang[0].culture;
		i18n.changeLanguage(culture);
		dispatch(changeUserLanguage(languageKey, culture, true));
		moment.locale(culture);
		cookies.set(c.COOKIE_KEY_LANGUAGE, culture, { path: '/', domain: config.app.authSettings.domain });
		if (updateUserPreferences) {
			const userPreferences = getState().userPreferences; //update user language preferences
			userPreferences.languageKey = languageKey;
			dispatch(putUserPreferences(userPreferences));
		}
	};
}
